// What a counterparty's fields look like on the register, in the table and on a tile alike.
// The tag lists are wrapped so the cell keeps its table layout and the tags wrap inside it.

import { countryLabel, countryName, flagOf, isCountryCode } from '../countries.js';
import { categoryLabel, statusLabel, subcategoriesOf, subcategoryLabel } from './labels.js';
import { averageLabel, averageText } from './ratings/ratings.js';

const tagList = (codes, label) =>
  codes.length === 0
    ? <span className="muted">—</span>
    : <span className="tags">{codes.map((code) => <span key={code} className="tag">{label(code)}</span>)}</span>;

// A category with its subcategories beside it: "Logistics: Transporter" (TX-US-0041).
export const categories = (record) => tagList(record.categories, (code) => {
  const own = subcategoriesOf(code).map((s) => s.code).filter((s) => (record.subcategories ?? []).includes(s));
  return own.length ? `${categoryLabel(code)}: ${own.map(subcategoryLabel).join(', ')}` : categoryLabel(code);
});

export const commodities = (record, products) =>
  tagList(record.commodities, (code) => products.find((p) => p.code === code)?.label ?? code);

// The flag and the name, where there is room.
export const country = (record) => countryLabel(record.country);

// "★ 3.8 (5)", read out as a sentence (TX-US-0040).
export const rating = (record) => (
  <span className={record.rating_count ? 'rating' : 'rating muted'} aria-label={averageLabel(record)}
        title={averageLabel(record)}>
    {averageText(record)}
  </span>
);

// The flag alone, named for a screen reader and on hover - the table's column is narrow. A value
// that is not a code has no flag and is shown as typed.
export const flag = (record) => {
  if (!record.country) return '';
  if (!isCountryCode(record.country)) return record.country;
  const code = record.country.toUpperCase();
  return (
    <span role="img" aria-label={countryName(code)} title={countryName(code)}>{flagOf(code)}</span>
  );
};

export const status = (record) => (
  <span className={`status status-${record.status.toLowerCase()}`}>{statusLabel(record.status)}</span>
);
